module.exports = __webpack_public_path__ + "static/media/yes.8ac11646.svg";